
import { ANSWER_MESSAGE, OrdenExpressGetUserCredentials, OrdenExpressValidateSecurityForAnswer } from 'orden_express/frameWork/frameWork';
import { ofType } from 'redux-observable';
import { URL_SERVER } from 'routes';
import { ajax } from 'rxjs/ajax';
import { of } from 'rxjs/index';
import { catchError, map, mergeMap } from 'rxjs/operators';

/**
 * Acción que permite solicitar al servidor los usuarios disponibles
 */
const REQUEST_GET_USERS = 'REQUEST_GET_USERS';
export const requestGetUsers = () => (
  {
    type: REQUEST_GET_USERS
  }
);
/**
 * Usado para almacenar el estado de respuesta de los usuarios disponibles en el servidor
 */
export const RESPONSE_GET_USERS = 'RESPONSE_GET_USERS';
export const responseGetUsers = (responseGetUsers) => (
  {
    type: RESPONSE_GET_USERS,
    responseGetUsers
  }
);
/**
 * Procesa de forma asíncrona la solicitud de los usuarios disponibles en el sistema
 * @param {*} action$ 
 */
export const fromServerGetUsers = (action$, state$) => action$.pipe(
  ofType(REQUEST_GET_USERS),
  mergeMap(action =>
    ajax.getJSON(URL_SERVER + '/user/getAll', OrdenExpressGetUserCredentials(state$.value)).pipe(
      map(response => responseGetUsers(OrdenExpressValidateSecurityForAnswer(response))),
      catchError(error => of(responseGetUsers(ANSWER_MESSAGE(true, 'Hubo problemas de conexión, intentelo nuevamente', error))))
    )
  )
);
/**
 * Usada para solicitar al servidor grabar los datos de usuario enviados
 */
const REQUEST_SAVE_USER = 'REQUEST_SAVE_USER';
export const requestSaveUser = requestSaveUser => (
  {
    type: REQUEST_SAVE_USER,
    requestSaveUser
  }
);
/**
 * Usada para almacenar la respuesta dada por el servidor al almacenamiento de datos
 */
export const RESPONSE_SAVE_USER = 'RESPONSE_SAVE_USER';
const responseSaveUser = responseSaveUser => (
  {
    type: RESPONSE_SAVE_USER,
    responseSaveUser
  }
);
/**
 * Realiza la solicitud asíncrona al servidor para almacenar los datos enviados del usuario
 * @param {*} action$ 
 */
export const fromServerSaveUser = (action$, state$) => action$.pipe(
  ofType(REQUEST_SAVE_USER),
  mergeMap(action =>
    ajax.post(URL_SERVER + '/user/save', action.requestSaveUser, OrdenExpressGetUserCredentials(state$.value)).pipe(
      map(response => responseSaveUser(OrdenExpressValidateSecurityForAnswer(response.response))),
      catchError(error => of(responseSaveUser(ANSWER_MESSAGE(true, 'Hubo problemas de conexión, intentelo nuevamente', error))))
    )
  )
);
const REQUEST_SAVE_DELIVERY_POINT = 'REQUEST_SAVE_DELIVERY_POINT';
export const requestSaveDeliveryPoint = requestSaveDeliveryPoint => (
  {
    type: REQUEST_SAVE_DELIVERY_POINT,
    requestSaveDeliveryPoint
  }
);
export const RESPONSE_SAVE_DELIVERY_POINT = 'RESPONSE_SAVE_DELIVERY_POINT';
const responseSaveDeliveryPoint = responseSaveDeliveryPoint => (
  {
    type: RESPONSE_SAVE_DELIVERY_POINT,
    responseSaveDeliveryPoint
  }
);
export const fromServerSaveDeliveryPoint = (action$, state$) => action$.pipe(
  ofType(REQUEST_SAVE_DELIVERY_POINT),
  mergeMap(action =>
    ajax.post(URL_SERVER + '/deliveryPoint/save', action.requestSaveDeliveryPoint, OrdenExpressGetUserCredentials(state$.value)).pipe(
      map(response => responseSaveDeliveryPoint(OrdenExpressValidateSecurityForAnswer(response.response))),
      catchError(error => of(responseSaveDeliveryPoint(ANSWER_MESSAGE(true, 'Hubo problemas de conexión, intentelo nuevamente', error))))
    )
  )
);
const REQUEST_GET_CITIES = 'REQUEST_GET_CITIES';
export const requestGetCities = () => (
  {
    type: REQUEST_GET_CITIES
  }
);
export const RESPONSE_GET_CITIES = 'RESPONSE_GET_CITIES';
const responseGetCities = responseGetCities => (
  {
    type: RESPONSE_GET_CITIES,
    responseGetCities
  }
);
export const fromServerGetCities = (action$, state$) => action$.pipe(
  ofType(REQUEST_GET_CITIES),
  mergeMap(action =>
    ajax.getJSON(URL_SERVER + '/city/getAll', OrdenExpressGetUserCredentials(state$.value)).pipe(
      map(response => responseGetCities(OrdenExpressValidateSecurityForAnswer(response))),
      catchError(error => of(responseGetCities(ANSWER_MESSAGE(true, 'Hubo problemas de conexión, intentelo nuevamente', error))))
    )
  )
);

export const REQUEST_RESET_STATE_USERS = 'REQUEST_RESET_STATE_USERS';
export const requestResetStateUsers = () => (
  {
    type: REQUEST_RESET_STATE_USERS
  }
);

export default this;